var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { ExplorerAsideHeader, ExplorerAsideHeaderDefaultProps } from './explorer-aside-header';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
import { SiteSidebar } from '../entities/site-sidebar';
import { LayoutTargetProvider } from '../context/layout-target-context';
import { ReservedWidthProvider } from '../context/reserved-width-context';
import { useEntityTypeDefinition } from '../context/entity-type-config-context';
import { isArray } from 'lodash';
import { useDimensionsFor } from '../hooks/use-dimensions-for';
import { useEntityTypeBanners } from '../hooks/use-entity-type-banners';
import { SiteFooterLayout } from '../entities/site-footer-layout';
import { useComponentProps } from '../context/component-props-context';
import { EntityViewTabs } from '../entities/entity-view-tabs';
import { EntityViewMain } from '../entities/entity-view-main';
import { EntityViewAside } from '../entities/entity-view-aside';
import { useEntityContentTabs } from '../hooks/use-entity-content-tabs';
var cls = classNames('explorer-entity-details-layout');
export var defaultExplorerEntityDetailsLayoutAsideSlots = ['meta', 'dataViz'];
export var ExplorerEntityDetailsLayoutDefaultProps = {
  asideHeaderProps: ExplorerAsideHeaderDefaultProps,
  split: [4, 5.5],
  asideMaxWidth: 600,
  stickyTopOffset: 130,
  isAsideSticky: true,
  asideIsOffset: true,
  showBanner: true,
  ignoreViews: false,
  asideVariant: 'attached',
  showAsideHeader: true,
  asideOrder: defaultExplorerEntityDetailsLayoutAsideSlots,
  showMetaHead: function () {
    return true;
  },
  showMetaFoot: function () {
    return true;
  },
  showDataVizHead: function () {
    return true;
  },
  showDataViz: function () {
    return true;
  },
  showDataVizFoot: function () {
    return true;
  },
  showSiteFooter: function () {
    return true;
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    flex: 1 0 0;  \n    background-color: ", ";\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    flex: 1 0 0;  \n    background-color: ", ";\n  "])), theme.COLOR('app-chrome'))
});
var AsideStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  \n    display: none;\n    flex-shrink: 0;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;    \n    background-color: ", ";\n    position: fixed;\n    transition: left 0.3s;\n    height: 100vh;\n    z-index: 500;\n    \n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    ", "\n  \n    display: none;\n    flex-shrink: 0;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;    \n    background-color: ", ";\n    position: fixed;\n    transition: left 0.3s;\n    height: 100vh;\n    z-index: 500;\n    \n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var isOffset = _a.isOffset;
    return isOffset && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-top: -14px;\n    "], ["\n      margin-top: -14px;\n    "])));
  }, theme.COLOR('app-chrome'), function (_a) {
    var _isRevealed = _a._isRevealed,
      _sidebarWidth = _a._sidebarWidth;
    return _isRevealed && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      left: ", ";\n      width: calc(100% - ", "px);\n      top: 0;\n    "], ["\n      left: ", ";\n      width: calc(100% - ", "px);\n      top: 0;\n    "])), _isRevealed ? 0 : '200vw', _sidebarWidth);
  }, function (_a) {
    var _percentageWidth = _a._percentageWidth;
    return _percentageWidth && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex-basis: ", "%;\n    "], ["\n      flex-basis: ", "%;\n    "])), _percentageWidth);
  }, function (_a) {
    var variant = _a.variant;
    return variant === 'detached' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      border-radius: 0 ", " 0 0;\n    "], ["\n      border-radius: 0 ", " 0 0;\n    "])), theme.UNIT(3));
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    z-index: 0;\n    position: static;\n    height: auto;\n    min-height: calc(100vh - 124px);\n    ", "\n    display: flex;\n  "], ["\n    display: flex;\n    z-index: 0;\n    position: static;\n    height: auto;\n    min-height: calc(100vh - 124px);\n    ", "\n    display: flex;\n  "])), function (_a) {
    var _maxWidth = _a._maxWidth;
    return _maxWidth && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), _maxWidth);
  })
});
var AsideMainStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    /* TODO - fix mobile approach with aside main */\n    display: none;\n  "], ["\n    ", ";\n    /* TODO - fix mobile approach with aside main */\n    display: none;\n  "])), AsideStyles),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var AsideHeaderStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DataVizContainerStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var DataVizMainContainerStyles = breakpoints({
  baseDevice: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))),
  desktopDevice: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var DataVizHeadStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DataVizStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DataVizFootStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MetaContainerStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var MetaHeadStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var MetaFootStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var MainStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    align-self: stretch;\n    background-color: ", ";\n    border-radius: ", " 0 0 0;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    width: 30%;\n\n    ", "\n  "], ["\n    align-self: stretch;\n    background-color: ", ";\n    border-radius: ", " 0 0 0;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    width: 30%;\n\n    ", "\n  "])), theme.COLOR('canvas'), theme.UNIT(2), function (_a) {
    var asideIsVisible = _a.asideIsVisible;
    return asideIsVisible && css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      padding: ", " ", " 0;\n    "], ["\n      padding: ", " ", " 0;\n    "])), theme.UNIT(4), theme.UNIT(4));
  }),
  desktop: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    width: 30%;\n\n    flex-grow: 1;\n    padding: ", " ", " 0;\n  "], ["\n    width: 30%;\n\n    flex-grow: 1;\n    padding: ", " ", " 0;\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var BannerAndTabsStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TabsStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    padding-top: ", ";\n    width: 100%;\n    position: absolute;\n    overflow-x: auto;\n  "], ["\n    padding-top: ", ";\n    width: 100%;\n    position: absolute;\n    overflow-x: auto;\n  "])), theme.UNIT(3))
});
var MainBodyStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasTabs = _a.hasTabs,
      tabMargin = _a.tabMargin;
    return hasTabs && css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n      margin-top: ", "px;\n    "], ["\n      margin-top: ", "px;\n    "])), tabMargin || 68);
  })
});
var MainContentStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var asideIsVisible = _a.asideIsVisible;
    return !asideIsVisible && css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      padding: 0 ", ";\n    "], ["\n      padding: 0 ", ";\n    "])), theme.UNIT(3));
  }),
  tablet: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    ", "\n    \n  "], ["\n    ", "\n    \n  "])), function (_a) {
    var asideIsVisible = _a.asideIsVisible;
    return !asideIsVisible && css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      padding: 0 ", ";\n    "], ["\n      padding: 0 ", ";\n    "])), theme.UNIT(4));
  }),
  desktop: css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var MainMetaHeadContainerStyles = breakpoints({
  base: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  desktopDevice: css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AsideLayoutContainerStyles = breakpoints({
  base: css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "]))),
  desktop: css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    \n    ", "\n\n    ", "\n  "], ["\n    \n    ", "\n\n    ", "\n  "])), function (_a) {
    var isSticky = _a.isSticky;
    return isSticky && css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n      position: sticky;\n    "], ["\n      position: sticky;\n    "])));
  }, function (_a) {
    var stickyTopOffset = _a.stickyTopOffset;
    return css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n      top: ", "px;\n    "], ["\n      top: ", "px;\n    "])), stickyTopOffset);
  })
});
var MainMetaFootContainerStyles = breakpoints({
  base: css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  desktopDevice: css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    padding: 0 ", ";\n    ", "\n  "], ["\n    padding: 0 ", ";\n    ", "\n  "])), theme.UNIT(1), function (_a) {
    var asideIsVisible = _a.asideIsVisible;
    return !asideIsVisible && css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n      padding: 0 ", ";\n    "], ["\n      padding: 0 ", ";\n    "])), theme.UNIT(2));
  })
});
var EntityViewMainStyles = breakpoints({
  base: css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityViewAsideStyles = breakpoints({
  base: css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'ExplorerEntityDetailsLayout',
  Container: styled.div(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Aside: styled.aside.attrs(cls.attr('aside'))(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  AsideMain: styled.aside.attrs(cls.attr('aside'))(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), AsideMainStyles),
  AsideLayoutContainer: styled.div.attrs(cls.attr('aside-layout-container'))(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), AsideLayoutContainerStyles),
  AsideHeader: styled(ExplorerAsideHeader).attrs(cls.attr('aside-header'))(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), AsideHeaderStyles),
  EntityViewAside: styled(EntityViewAside)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), EntityViewAsideStyles),
  DataVizMainContainer: styled.div.attrs(cls.attr('data-viz-main-container'))(templateObject_54 || (templateObject_54 = __makeTemplateObject(["", ""], ["", ""])), DataVizMainContainerStyles),
  DataVizContainer: styled.div.attrs(cls.attr('aside-layout-container'))(templateObject_55 || (templateObject_55 = __makeTemplateObject(["", ""], ["", ""])), DataVizContainerStyles),
  DataVizHead: styled.div.attrs(cls.attr('data-viz-head'))(templateObject_56 || (templateObject_56 = __makeTemplateObject(["", ""], ["", ""])), DataVizHeadStyles),
  DataViz: styled.div.attrs(cls.attr('data-viz'))(templateObject_57 || (templateObject_57 = __makeTemplateObject(["", ""], ["", ""])), DataVizStyles),
  DataVizFoot: styled.div.attrs(cls.attr('data-viz-foot'))(templateObject_58 || (templateObject_58 = __makeTemplateObject(["", ""], ["", ""])), DataVizFootStyles),
  MetaContainer: styled.div.attrs(cls.attr('meta-container'))(templateObject_59 || (templateObject_59 = __makeTemplateObject(["", ""], ["", ""])), MetaContainerStyles),
  MetaHead: styled.div.attrs(cls.attr('meta-head'))(templateObject_60 || (templateObject_60 = __makeTemplateObject(["", ""], ["", ""])), MetaHeadStyles),
  MetaFoot: styled.div.attrs(cls.attr('meta-foot'))(templateObject_61 || (templateObject_61 = __makeTemplateObject(["", ""], ["", ""])), MetaFootStyles),
  Main: styled.main.attrs(cls.attr('main'))(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  BannerAndTabs: styled.div.attrs(cls.attr('banner-and-tabs'))(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), BannerAndTabsStyles),
  Banner: styled.div.attrs(cls.attr('banner'))(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Tabs: styled.div.attrs(cls.attr('tabs'))(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  MainBody: styled.div.attrs(cls.attr('main-body'))(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), MainBodyStyles),
  MainContent: styled.div(templateObject_67 || (templateObject_67 = __makeTemplateObject(["", ""], ["", ""])), MainContentStyles),
  MainMetaHeadContainer: styled.div.attrs(cls.attr('main-meta-head-container'))(templateObject_68 || (templateObject_68 = __makeTemplateObject(["", ""], ["", ""])), MainMetaHeadContainerStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_69 || (templateObject_69 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  EntityViewMain: styled(EntityViewMain)(templateObject_70 || (templateObject_70 = __makeTemplateObject(["", ""], ["", ""])), EntityViewMainStyles),
  MainMetaFootContainer: styled.div.attrs(cls.attr('main-meta-foot-container'))(templateObject_71 || (templateObject_71 = __makeTemplateObject(["", ""], ["", ""])), MainMetaFootContainerStyles),
  Footer: styled(SiteFooterLayout)(templateObject_72 || (templateObject_72 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
export var ExplorerEntityDetailsLayout = function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var componentProps = useComponentProps(My.NAME, ExplorerEntityDetailsLayoutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    showAsideHeader = componentProps.showAsideHeader,
    asideIsOffset = componentProps.asideIsOffset,
    showBanner = componentProps.showBanner,
    split = componentProps.split,
    asideIsRevealed = componentProps.asideIsRevealed,
    asideHeaderProps = componentProps.asideHeaderProps,
    asideMaxWidth = componentProps.asideMaxWidth,
    stickyTopOffset = componentProps.stickyTopOffset,
    isAsideSticky = componentProps.isAsideSticky,
    asideOrder = componentProps.asideOrder,
    asideVariant = componentProps.asideVariant,
    mainGapUnits = componentProps.mainGapUnits,
    asideGapUnits = componentProps.asideGapUnits,
    showMetaHead = componentProps.showMetaHead,
    showMetaFoot = componentProps.showMetaFoot,
    showDataVizHead = componentProps.showDataVizHead,
    showDataViz = componentProps.showDataViz,
    showDataVizFoot = componentProps.showDataVizFoot,
    showSiteFooter = componentProps.showSiteFooter,
    ignoreViews = componentProps.ignoreViews;
  var entityTypeName = entityTypeNameFor(entity);
  var defn = useEntityTypeDefinition(entityTypeName);
  var tabRef = useRef(null);
  var tabDimensions = useDimensionsFor(tabRef);
  // todo - consolidate entity type config into one place
  var banners = useEntityTypeBanners();
  var BannerComponent = banners[entityTypeName] || ((_a = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _a === void 0 ? void 0 : _a.bannerComponent);
  var TabsComponent = (_b = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _b === void 0 ? void 0 : _b.tabsComponent;
  var ContentComponent = (_c = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _c === void 0 ? void 0 : _c.contentComponent;
  var DataVizHeadComponent = (_d = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _d === void 0 ? void 0 : _d.dataVizHeaderComponent;
  var DataVizComponent = (_e = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _e === void 0 ? void 0 : _e.dataVizComponent;
  var DataVizFootComponent = (_f = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _f === void 0 ? void 0 : _f.dataVizFootComponent;
  var MetaHeadComponent = (_g = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _g === void 0 ? void 0 : _g.metaHeadComponent;
  var MetaFootComponent = (_h = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _h === void 0 ? void 0 : _h.metaFooterComponent;
  var DataVizHeadMainComponent = (_j = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _j === void 0 ? void 0 : _j.dataVizHeadMainComponent;
  var DataVizMainComponent = (_k = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _k === void 0 ? void 0 : _k.dataVizMainComponent;
  var DataVizFootMainComponent = (_l = defn === null || defn === void 0 ? void 0 : defn.explorer) === null || _l === void 0 ? void 0 : _l.dataVizFootMainComponent;
  var sidebar = useSiteSidebar();
  var asideRef = useRef(null);
  var asideDimensions = useDimensionsFor(asideRef);
  var asideIsVisible = asideDimensions.width > 0;
  var navigationProps = asideHeaderProps.navigationProps;
  var _m = __read(isArray(split) && (split === null || split === void 0 ? void 0 : split.length) === 2 ? split : [4, 6], 2),
    asideWidth = _m[0],
    mainWidth = _m[1];
  var asidePercentageWidth = asideWidth / (asideWidth + mainWidth) * 100;
  var contentTabs = useEntityContentTabs(entity);
  // we need to render these into variables so we can conditionally render their containers
  // noting that we don't know if a component definition will render anything until we render it here
  // to that end, meta components should be setup to return null if they can't logically render anything
  var tabs = componentProps.tabs || TabsComponent && React.createElement(TabsComponent, {
    entity: entity
  });
  var banner = componentProps.banner || BannerComponent && React.createElement(BannerComponent, {
    entity: entity
  });
  var metaHead = componentProps.metaHead || MetaHeadComponent && React.createElement(MetaHeadComponent, {
    entity: entity
  });
  var metaFoot = componentProps.metaFoot || MetaFootComponent && React.createElement(MetaFootComponent, {
    entity: entity
  });
  var content = componentProps.content || ContentComponent && React.createElement(ContentComponent, {
    entity: entity
  }) || !ignoreViews && React.createElement(My.EntityViewMain, {
    entity: entity
  });
  var dataVizHead = componentProps.dataVizHead || DataVizHeadComponent && React.createElement(DataVizHeadComponent, {
    entity: entity
  });
  var dataViz = componentProps.dataViz || DataVizComponent && React.createElement(DataVizComponent, {
    entity: entity
  });
  var dataVizFoot = componentProps.dataVizFoot || DataVizFootComponent && React.createElement(DataVizFootComponent, {
    entity: entity
  });
  var hasMetaHead = !!metaHead;
  var hasMetaFoot = !!metaFoot;
  var hasDataVizContainer = dataVizHead || dataViz || dataVizFoot;
  // we need to re-render these within the DeviceTargetProvider, but still check for existence via the normal component render 
  var metaHeadMain = hasMetaHead && React.createElement(LayoutTargetProvider, {
    value: "main"
  }, componentProps.metaHead || MetaHeadComponent && React.createElement(MetaHeadComponent, {
    entity: entity
  }));
  var metaFootMain = hasMetaFoot && React.createElement(LayoutTargetProvider, {
    value: "main"
  }, componentProps.metaFoot || MetaFootComponent && React.createElement(MetaFootComponent, {
    entity: entity
  }));
  var dataVizHeadMain = componentProps.dataVizHeadMain && React.createElement(LayoutTargetProvider, {
    value: "main"
  }, componentProps.dataVizHeadMain || DataVizHeadMainComponent && React.createElement(DataVizHeadMainComponent, {
    entity: entity
  }));
  var dataVizMain = componentProps.dataVizMain && React.createElement(LayoutTargetProvider, {
    value: "main"
  }, componentProps.dataVizMain || DataVizMainComponent && React.createElement(DataVizMainComponent, {
    entity: entity
  }));
  var dataVizFootMain = componentProps.dataVizFootMain && React.createElement(LayoutTargetProvider, {
    value: "main"
  }, componentProps.dataVizFootMain || DataVizFootMainComponent && React.createElement(DataVizFootMainComponent, {
    entity: entity
  }));
  var hasDataVizMainContainer = dataVizHeadMain || dataVizMain || dataVizFootMain;
  var hasContent = !!content;
  var hasMeta = metaHead || metaFoot;
  var hasAutoTabs = !(contentTabs && contentTabs.length <= 1);
  var hasTabs = !!tabs;
  var hasBanner = !!banner;
  var asideLayout = React.createElement(My.AsideLayoutContainer, {
    stickyTopOffset: stickyTopOffset,
    isSticky: isAsideSticky
  }, showAsideHeader && /* @ts-ignore */
  React.createElement(My.AsideHeader, {
    variant: asideVariant,
    navigationProps: navigationProps,
    entity: entity
  }), !ignoreViews && React.createElement(My.EntityViewAside, {
    entity: entity
  }), asideOrder.map(function (slot) {
    if (slot === 'meta') {
      return hasMeta && React.createElement(My.MetaContainer, null, metaHead && React.createElement(My.MetaHead, null, metaHead), metaFoot && React.createElement(My.MetaFoot, null, metaFoot));
    }
    if (slot === 'dataViz') {
      return hasDataVizContainer && React.createElement(My.DataVizContainer, null, dataVizHead && React.createElement(My.DataVizHead, null, dataVizHead), dataViz && React.createElement(My.DataViz, null, dataViz), dataVizFoot && React.createElement(My.DataVizFoot, null, dataVizFoot));
    }
  }));
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Aside, {
    isOffset: asideIsOffset,
    variant: asideVariant,
    ref: asideRef,
    _sidebarWidth: sidebar.width,
    _isRevealed: asideIsRevealed,
    _percentageWidth: asidePercentageWidth,
    _maxWidth: asideMaxWidth
  }, asideLayout), React.createElement(My.AsideMain, {
    isOffset: false,
    variant: 'attached',
    _sidebarWidth: sidebar.width,
    _isRevealed: asideIsRevealed,
    _percentageWidth: asidePercentageWidth,
    _maxWidth: asideMaxWidth
  }, asideLayout), asideIsRevealed && React.createElement(SiteSidebar, null), React.createElement(ReservedWidthProvider, {
    value: asideDimensions.width
  }, React.createElement(My.Main, {
    asideIsVisible: asideIsVisible,
    hasGap: hasTabs || hasAutoTabs
  }, (hasBanner || hasTabs || hasAutoTabs) && React.createElement(My.BannerAndTabs, null, hasBanner && showBanner && React.createElement(My.Banner, null, banner), hasAutoTabs && React.createElement(My.Tabs, {
    ref: tabRef
  }, React.createElement(EntityViewTabs, {
    entity: entity
  })), hasTabs && !hasAutoTabs && React.createElement(My.Tabs, {
    ref: tabRef
  }, tabs)), React.createElement(My.MainBody, {
    hasTabs: hasTabs || hasAutoTabs,
    tabMargin: tabDimensions.height
  }, hasDataVizMainContainer && React.createElement(My.DataVizMainContainer, null, dataVizHeadMain && showDataVizHead('main') && React.createElement(My.DataVizHead, null, dataVizHeadMain), dataVizMain && showDataViz('main') && React.createElement(My.DataViz, null, dataVizMain), dataVizFootMain && showDataVizFoot('main') && React.createElement(My.DataVizFoot, null, dataVizFootMain)), React.createElement(My.MainContent, {
    asideIsVisible: asideIsVisible
  }, metaHeadMain && showMetaHead('main') && React.createElement(My.MainMetaHeadContainer, null, React.createElement(My.MetaHead, null, metaHeadMain)), hasContent && React.createElement(My.Content, null, content), metaFootMain && showMetaFoot('main') && React.createElement(My.MainMetaFootContainer, null, React.createElement(My.MetaFoot, null, metaFootMain))), children), showSiteFooter() && React.createElement(My.Footer, {
    asideIsVisible: asideIsVisible
  }))));
};
ExplorerEntityDetailsLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72;